import VehicleDetails from '@/models/VehicleDetails';

export default {
  vehicleDetails: new VehicleDetails(),
  vehicleResults: [],
};
